module.exports = __webpack_public_path__ + "img/sft_logo.09bcaab0.png";